import React, { Component } from 'react'
import { Manager, Reference, Popper } from 'react-popper'
import injectSheet from 'react-jss'
import styles from './popover.styles.js'
import classNames from 'classnames'
import PropTypes from 'prop-types'

class Popover extends Component {
  constructor(props) {
    super(props)
    this.buttonNode = null
    this.contentNode = null
  }
  componentDidMount() {
    this.registerEventListeners()
  }
  componentWillUnmount() {
    this.removeEventListeners()
  }
  removeEventListeners() {
    document.removeEventListener('click', this.outsideClick)
  }
  registerEventListeners() {
    document.addEventListener('click', this.outsideClick)
  }
  outsideClick = e => {
    let node = e.target
    let nodesFound = false
    while (node.parentNode) {
      if (node === this.buttonNode || node === this.contentNode) {
        nodesFound = true
        break
      }
      node = node.parentNode
    }
    if (!nodesFound) this.closePopper()
  }
  closePopper() {
    const { requestClose } = this.props
    requestClose && requestClose()
  }
  showPopper() {
    const { requestOpen } = this.props
    requestOpen && requestOpen()
  }
  toggle() {
    const { opened } = this.props
    opened ? this.closePopper() : this.showPopper()
  }
  render() {
    const {
      classes,
      opened,
      children,
      button,
      className,
      placement = 'bottom-start'
    } = this.props
    return (
      <Manager>
        <Reference innerRef={node => (this.buttonNode = node)}>
          {({ ref }) =>
            button && button({ ref, togglePopover: this.toggle.bind(this) })
          }
        </Reference>
        {opened && (
          <Popper
            innerRef={node => (this.contentNode = node)}
            placement={placement}
            modifiers={{
              keepTogether: { enabled: false }
            }}>
            {({ ref, style, placement }) => {
              return (
                <div
                  ref={ref}
                  style={style}
                  className={classNames(classes.popperContainer, {
                    [classes.opened]: opened
                  })}
                  data-placement={placement}>
                  <div
                    className={classNames(
                      classes.popper,
                      classes[placement],
                      className
                    )}>
                    {children}
                  </div>
                </div>
              )
            }}
          </Popper>
        )}
      </Manager>
    )
  }
}

Popover.propTypes = {
  /** Controll opened state of the popover */
  opened: PropTypes.bool.isRequired,
  /** Render props pattern function that recieves ref and onClick as parameters  */
  button: PropTypes.func.isRequired,
  /** Placement of the popover (react-popper docs) */
  placement: PropTypes.string,
  /** This will appear in the body of popover */
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.string
  ]),
  /** Callback when requesting to open popover */
  requestOpen: PropTypes.func.isRequired,
  /** Callback when requesting to close popover */
  requestClose: PropTypes.func.isRequired,
  /** Additional className to restyle component */
  className: PropTypes.string
}

export default injectSheet(styles)(Popover)
